import type { Fetcher } from 'swr';
import useSWR from 'swr';

import { clientsAccessibleClientGroupsList } from '~/data/generated/endpoints/clients/clients';
import type { ClientGroup } from '~/data/generated/model';

const accessibleClientGroupsFetcher: Fetcher<
  ClientGroup[],
  readonly ['accessible-client-groups']
> = async () => {
  try {
    const { data } = await clientsAccessibleClientGroupsList();
    return data;
  } catch (error) {
    console.error('Error fetching accessible client groups:', error);
    // Return empty array if endpoint doesn't exist yet
    return [];
  }
};

export type UseAccessibleClientGroupsHook = {
  accessibleClientGroups: ClientGroup[] | undefined;
  isLoading: boolean;
  error: unknown;
};

/**
 * Returns all accessible client groups available to the authenticated user.
 */
export default function useAccessibleClientGroups(enabled = true): UseAccessibleClientGroupsHook {
  const { data, error, isLoading } = useSWR(
    enabled ? (['accessible-client-groups'] as const) : null,
    accessibleClientGroupsFetcher,
  );

  return {
    accessibleClientGroups: data || [],
    isLoading: isLoading,
    error,
  };
}
